import React, { Component } from "react";
import {Grid, Avatar, Typography, Button, Icon, Select, MenuItem, Modal} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { webFont, textBlack, textGrey, primaryColor } from '../../config/theme';
import { client } from "../../config/apollo";
import { FEATURED_CHEFS } from "../../graphql/queries/chef";
import { setFeaturedChefs } from "../../redux/chefs";
import {CREATE_DINER_JOB} from "../../graphql/mutations/chef";
import moment from "moment";

const defaultChefImg = "/images/simple-chef.webp";
const tick = "/images/tick.webp";

const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

class FChefs extends Component {
  state = {
    featuredChefsList: [],
    openModal: true,
    selectedDate: 20,
    selectedMonth: 'Jan',
    description: '',
    selectedHour: 15,
    selectedMinute: '00'
  };

  componentDidMount() {
    const now = moment();
    this.setState({
      selectedDate: parseInt(now.format('DD')),
      selectedMonth: now.format('MMM')
    });
    client
      .query({
        query: FEATURED_CHEFS,
        variables: {
          chefCount: 8
        }
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.featuredChefs) {
            let featuredChefs = resp.data.featuredChefs;

            this.setState({ featuredChefsList: featuredChefs });
            setFeaturedChefs(resp.data.featuredChefs);
          }
        }
      })
      .catch(err => {
        console.error("FEATURED CHEFS: ", err);
      });
  }

  showChefProfile = chefId => {
    this.props.history.push("/home/chef-profile", { chefId });
  };

  handleFindMeAChef = () => {
    const jobDate = `${this.state.selectedDate} ${this.state.selectedMonth}`;
    const jobTime = `${this.state.selectedHour}:${this.state.selectedMinute}`;

    client.mutate({
      mutation: CREATE_DINER_JOB,
      variables: {
        jobDate,
        jobTime,
        description: this.state.description
      }
    }).then(() => {
      this.setState({ selectedDate: 1, selectedMonth: 'Jan', description: '', openModal: false });
      NotificationManager.info('We will get back to you with this in 3 business days through email.', 'Find chef', 5000);
    })
        .catch(err => {
          NotificationManager.error('Oops! There was an error. Please try again.', 'Find chef', 3500);
        });
  };

  render() {
    const { featuredChefsList } = this.state;

    let fChefs = null;
    if (featuredChefsList.length > 0) {
      fChefs = featuredChefsList.map(chef => {
        let chefRatings = 0;
        let ratingStars = null;

        if (chef.rating) {
          if (chef.rating > 0) {
            chefRatings = Math.floor(chef.rating);
          }
        }

        if (chefRatings > 0) {
          switch (chefRatings) {
            case 1:
              ratingStars = <Icon style={style.ratingIcon}>star_rate</Icon>;
              break;

            case 2:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;

            case 3:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;

            case 4:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;

            case 5:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;
          }
        } else {
          chefRatings = "";
        }

        const chefCuisines = (chef.cuisines && chef.cuisines.length>0) ? chef.cuisines.length >= 2 ? "Multi Cuisines" : chef.cuisines.toString().replace(/,/g, ', ') : "No Cuisines";

        return (
          <Grid  data-test-id={"featchef-list"}
            container
            xs={12}
            sm={4}
            md={4}
            lg={3}
            key={chef.id}
            style={style.featuredItem}
            onClick={() => this.showChefProfile(chef.id)}
            alignItems={'center'}
            justify={'center'}
          >
            <Grid item alignItems="center" justify="center" style={{ position: 'relative' }}>
              <Avatar
                src={chef.profilePic ? chef.profilePic : defaultChefImg}
                alt="Image not available"
                style={style.avatarImg}
              />
              {chef.verified && <div style={{ position: 'absolute', top: 0, right: 10 }}>
                <img src={tick} alt="Verified Chef" style={style.tick} />
              </div>}
              <Grid item xs={12}>
                <Typography
                  align="center"
                  variant="h6"
                  style={style.chefName}
                  gutterBottom={true}
                >
                  {chef.firstName} {chef.lastName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  align="center"
                  variant="body1"
                  style={style.chefCuisine}
                  gutterBottom={true}
                  noWrap={true}
                >
                  {chefCuisines}
                </Typography>
              </Grid>
              <Grid item xs={12} alignItems={"center"} alignContent={"center"} justify={"center"}>
                <Typography
                  align="center"
                  variant="body1"
                  style={style.chefCuisine}
                  gutterBottom={true}
                  noWrap={true}
                >
                  {chefRatings === '' ? chefRatings : ratingStars}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        );
      });
    }

    if (featuredChefsList.length < 8) {
      return (
          <Modal
              disableEscapeKeyDown={true}
              onClose={() => this.setState({ openModal: false })}
              open={this.state.openModal}
              aria-labelledby={"get-diner-details"}>
            <div className="diner-details-for-chef-container">
              <h2>We would love to have a dinner with you some fine day.</h2>
              <h3>Meanwhile, let's find a chef to cook delicious delicacies which will soothe your taste buds!</h3>

              <div className="diner-details-form-wrapper">
                <div className="diner-details-form-input-wrapper">
                  <label>When do you need a chef ?</label>
                  <div className="diner-details-time-wrapper">
                    <div className="diner-details-date-wrapper">
                      <span className="inner-label">Date</span>
                      <Select
                        inputProps={{MenuProps: {disableScrollLock: true}}}
                          className="select-option"
                          data-test-id={"fromminute-id"}
                          value={parseInt(this.state.selectedDate)}
                          onChange={
                            evt => this.setState({ selectedDate: evt.target.value })
                          }
                          style={{ fontSize: "18px",
                            fontWeight:300,
                            fontFamily: webFont, marginLeft: 20 }}
                      >
                        {days.map(monthDay => (
                            <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                              fontWeight:300,
                              fontFamily: webFont }}>
                              {monthDay}
                            </MenuItem>
                        ))}

                      </Select>
                      <Select
                        inputProps={{MenuProps: {disableScrollLock: true}}}
                          className="select-option"
                          data-test-id={"frommonth-id"}
                          value={this.state.selectedMonth}
                          style={{ fontSize: "18px",
                            fontWeight:300,
                            fontFamily: webFont, marginLeft: 20 }}
                          onChange={
                            evt => this.setState({ selectedMonth: evt.target.value })
                          }
                      >
                        {months.map(monthDay => (
                            <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                              fontWeight:300,
                              fontFamily: webFont }}>
                              {monthDay}
                            </MenuItem>
                        ))}

                      </Select>

                      <span className="inner-label" style={{ marginLeft: 30 }}>Time</span>
                      <Select
                        inputProps={{MenuProps: {disableScrollLock: true}}}
                        className="select-option"
                        data-test-id={"fromhour-id"}
                        value={this.state.selectedHour}
                        style={{ fontSize: "18px",
                          fontWeight:300,
                          fontFamily: webFont, marginLeft: 20 }}
                        onChange={
                          evt => this.setState({ selectedHour: evt.target.value })
                        }
                      >
                        {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23].map(monthDay => (
                          <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                            fontWeight:300,
                            fontFamily: webFont }}>
                            {monthDay}
                          </MenuItem>
                        ))}

                      </Select>
                      <Select
                        inputProps={{MenuProps: {disableScrollLock: true}}}
                        className="select-option"
                        data-test-id={"fromminute-id"}
                        value={this.state.selectedMinute}
                        style={{ fontSize: "18px",
                          fontWeight:300,
                          fontFamily: webFont, marginLeft: 20 }}
                        onChange={
                          evt => this.setState({ selectedMinute: evt.target.value })
                        }
                      >
                        {['00', '15', '30', '45'].map(monthDay => (
                          <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                            fontWeight:300,
                            fontFamily: webFont }}>
                            {monthDay}
                          </MenuItem>
                        ))}

                      </Select>
                    </div>
                  </div>
                </div>

                <div className="diner-details-form-input-wrapper">
                  <label>Describe the job</label>
                  <textarea
                      rows={6}
                      placeholder="What is the occasion? &#10;How many people will be there? &#10;What sort of dishes are you looking forward to? &#10;What are you willing to pay?"
                      value={this.state.description}
                      onChange={evt => this.setState({ description: evt.target.value })}
                  />
                </div>

                <button onClick={this.handleFindMeAChef}>
                  Find me a Chef
                </button>
                <button onClick={() => this.setState({ openModal: false })}>
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
      );
    }

    return (
      <Grid className="saved-item-container" container direction="row" style={style.ftGrid}>
        <Grid container alignItems="flex-start">
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
          <Grid item xs={6} md={4} lg={4} xl={2} >
            <Typography variant="h5" style={style.ftText} align={"center"}>
              Featured chefs
            </Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
        </Grid>
        <Grid container alignItems={"center"} justify={"center"}>
        {fChefs}
        </Grid>
        <Grid container alignItems="center" justify="center">
          <Button
          data-test-id={"featchef-showall"}

            variant="contained"
            color="primary"
            onClick={() => this.props.history.push("/home/chef-search")}
            style={style.showBtn}
          >
            Show All
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    featuredChefs: state.chefs.featuredChefs
  };
};

const FeaturedChefs = connect(mapStateToProps)(FChefs);

export default FeaturedChefs;

const style = {
  avatarImg: {
    width: 203,
    height: 203,
    border: '1px solid #ff8000'
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 203
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  ratings: {
    color: primaryColor,
    weight: 500,
    maxWidth: '100%'
  },
  ratingIcon: {
    color: primaryColor
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30,
    fontFamily: webFont,
    color: '#fff'
  },
  tick: {
    width: 28,
    height: 28,
  }
};
